// src/app/store.ts
import { configureStore } from '@reduxjs/toolkit';
import userReducer from 'features/user/userSlice';
import brandingReducer from 'features/server/brandingSlice';
import actionsReducer from 'features/user/actionSlice';
import notificationsReducer from 'features/user/notificationSlice';
import subscriptionsReducer from 'features/subscription/subscriptionSlice';
const store = configureStore({
  reducer: {
    user: userReducer,
    branding: brandingReducer,
    actions: actionsReducer,
    notifications: notificationsReducer,
    subscriptions: subscriptionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
